import { render, staticRenderFns } from "./MapSession.vue?vue&type=template&id=2f88889e&scoped=true"
import script from "./MapSession.vue?vue&type=script&lang=js"
export * from "./MapSession.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f88889e",
  null
  
)

export default component.exports